import { UserRoleEnum } from '@enums/user-role.enum';

export const EventConstant = {
  assignLegEvent: 'assignLegEvent',
  changeLegStatusEvent: 'changeLegStatusEvent',
  removeLegAssignmentEvent: 'removeLegAssignmentEvent',
  serviceRequestCreatedEvent: 'serviceRequestCreatedEvent',
  vendorAssignmentRequestEvent: 'vendorAssignmentRequestEvent',
  serviceRequestStatusUpdateEvent: 'ServiceRequestStatusUpdateEvent',
  legDeletionEvent: 'LegDeletionEvent',
  updateLegTimeStampEvent: 'UpdateLegTimeStampEvent',
  customersRequestChangeEvent: 'CustomersRequestChangeEvent',
  assignedFeedbackCountEvent: 'AssignedFeedbackCountEvent',
  customersPendingRequestsChangeEvent: 'CustomersPendingRequestsChangeEvent',
  notificationsUpdateEvent: 'NotificationsUpdateEvent',
  serviceRequestApprovedOrRejectedEvent: 'ServiceRequestApprovedOrRejectedEvent',
  internalTripNotificationEvent: 'InternalNotificationEvent',
  itineraryReadyEvent: 'ItineraryReadyEvent',
  serviceRequestFlagEvent: 'SRFlagEvent',
  customerFinanceApprovalEvent: 'CustomerFinanceApprovalEvent',
};

export const serverTimeoutInMilliseconds: number = 240000; //4 minutes
export const maxRetries: number = 3;

export const EventMap: string[] = [
  EventConstant.changeLegStatusEvent,
  EventConstant.vendorAssignmentRequestEvent,
  EventConstant.serviceRequestStatusUpdateEvent,
  EventConstant.updateLegTimeStampEvent,
];

export const RoleEventMap: { [key: string]: string[] } = {
  [UserRoleEnum.EXECUTIVE_ADMIN]: [
    EventConstant.serviceRequestCreatedEvent,
    EventConstant.serviceRequestStatusUpdateEvent,
    EventConstant.changeLegStatusEvent,
    EventConstant.assignLegEvent,
    EventConstant.removeLegAssignmentEvent,
    EventConstant.legDeletionEvent,
    EventConstant.updateLegTimeStampEvent,
    EventConstant.serviceRequestFlagEvent,
    EventConstant.assignedFeedbackCountEvent,
  ],
  [UserRoleEnum.COORDINATOR]: [
    EventConstant.serviceRequestCreatedEvent,
    EventConstant.serviceRequestStatusUpdateEvent,
    EventConstant.changeLegStatusEvent,
    EventConstant.assignLegEvent,
    EventConstant.removeLegAssignmentEvent,
    EventConstant.legDeletionEvent,
    EventConstant.updateLegTimeStampEvent,
    EventConstant.customersPendingRequestsChangeEvent,
    EventConstant.internalTripNotificationEvent,
    EventConstant.serviceRequestFlagEvent,
    EventConstant.assignedFeedbackCountEvent,
  ],
  [UserRoleEnum.MANAGEMENT]: [
    EventConstant.serviceRequestCreatedEvent,
    EventConstant.serviceRequestStatusUpdateEvent,
    EventConstant.changeLegStatusEvent,
    EventConstant.assignLegEvent,
    EventConstant.removeLegAssignmentEvent,
    EventConstant.legDeletionEvent,
    EventConstant.updateLegTimeStampEvent,
    EventConstant.customersPendingRequestsChangeEvent,
    EventConstant.internalTripNotificationEvent,
    EventConstant.serviceRequestFlagEvent,
    EventConstant.assignedFeedbackCountEvent,
  ],
  [UserRoleEnum.DRIVER]: [
    EventConstant.changeLegStatusEvent,
    EventConstant.assignLegEvent,
    EventConstant.removeLegAssignmentEvent,
    EventConstant.legDeletionEvent,
    EventConstant.assignedFeedbackCountEvent,
  ],
  [UserRoleEnum.ACCOUNTING]: [
    EventConstant.changeLegStatusEvent,
    EventConstant.updateLegTimeStampEvent,
    EventConstant.assignedFeedbackCountEvent,
    EventConstant.customerFinanceApprovalEvent,
  ],
  [UserRoleEnum.INTERNAL_READONLY]: [EventConstant.changeLegStatusEvent, EventConstant.assignedFeedbackCountEvent],
  [UserRoleEnum.CUSTOMER_ADMIN]: [
    EventConstant.customersRequestChangeEvent,
    EventConstant.serviceRequestStatusUpdateEvent,
    EventConstant.changeLegStatusEvent,
    EventConstant.updateLegTimeStampEvent,
    EventConstant.notificationsUpdateEvent,
    EventConstant.itineraryReadyEvent,
  ],
  [UserRoleEnum.CUSTOMER_COORDINATOR]: [
    EventConstant.customersRequestChangeEvent,
    EventConstant.serviceRequestStatusUpdateEvent,
    EventConstant.changeLegStatusEvent,
    EventConstant.updateLegTimeStampEvent,
    EventConstant.notificationsUpdateEvent,
    EventConstant.itineraryReadyEvent,
  ],
  [UserRoleEnum.VENDOR_ADMIN]: [EventConstant.changeLegStatusEvent, EventConstant.vendorAssignmentRequestEvent],
  [UserRoleEnum.VENDOR_COORDINATOR]: [EventConstant.changeLegStatusEvent, EventConstant.vendorAssignmentRequestEvent],
  [UserRoleEnum.VENDOR_DRIVER]: [
    EventConstant.changeLegStatusEvent,
    EventConstant.assignLegEvent,
    EventConstant.removeLegAssignmentEvent,
    EventConstant.legDeletionEvent,
  ],
};
